export default __webpack_public_path__ + "static/media/avatars@3x.dd602542.png";